(function () {
  const input = document.getElementById('cateringGuestCount');
  const live = document.getElementById('cateringTierLive');
  const cards = document.querySelectorAll('.tpb-tier-card');
  if (!input || !live) return;

  function update() {
    const count = parseInt(input.value, 10);
    cards.forEach(c => c.classList.remove('hit'));
    live.classList.remove('hit');
    if (!count) {
      live.textContent = 'Enter your guest count to see your estimated discount.';
      return;
    }
    let matched = null;
    cards.forEach(c => {
      const min = parseInt(c.dataset.min, 10);
      const max = parseInt(c.dataset.max, 10);
      if (count >= min && count <= max) matched = c;
    });
    if (matched) {
      matched.classList.add('hit');
      live.classList.add('hit');
      const pct = matched.querySelector('.tpb-tier-discount').textContent;
      live.textContent = `${count} guests qualifies for ${pct} your catering quote.`;
    } else if (count < 10) {
      live.textContent = 'Groups under 10 guests are welcome too - just call for pricing.';
    }
  }
  input.addEventListener('input', update);
})();